export const TELEGRAM_THEME_VARS = {
  light: {
    '--tgui--bg_color': '#ffffff',
    '--tgui--button_color': '#2481cc',
    '--tgui--button_text_color': '#ffffff',
    '--tgui--secondary_fill': 'rgba(36, 129, 204, 0.16)',
    '--tgui--link_color': '#2481cc',
    '--tgui--plain_background': 'rgba(36, 129, 204, 0.12)',
    '--tgui--plain_foreground': '#1f2937',
    '--tgui--outline': 'rgba(15, 23, 42, 0.18)',
    '--tgui--white': '#ffffff',
    '--tgui--surface_dark': '#111827',
    '--tgui--surface_primary': '#ffffff',
    '--tgui--secondary_hint_color': '#64748b',
    '--tgui--destructive_text_color': '#d92d20',
    '--tgui--z-index--simple': 1,
  },
  dark: {
    '--tgui--bg_color': '#0f172a',
    '--tgui--button_color': '#2ea6ff',
    '--tgui--button_text_color': '#0b1220',
    '--tgui--secondary_fill': 'rgba(46, 166, 255, 0.2)',
    '--tgui--link_color': '#82cfff',
    '--tgui--plain_background': 'rgba(130, 207, 255, 0.2)',
    '--tgui--plain_foreground': '#f8fafc',
    '--tgui--outline': 'rgba(226, 232, 240, 0.38)',
    '--tgui--white': '#f8fafc',
    '--tgui--surface_dark': '#0b1220',
    '--tgui--surface_primary': '#111827',
    '--tgui--secondary_hint_color': '#94a3b8',
    '--tgui--destructive_text_color': '#ff7f7f',
    '--tgui--z-index--simple': 1,
  }
}

export const mergeClasses = function (values) {
  return values.filter(Boolean).join(' ')
}
